export default __webpack_public_path__ + "992894c70894432ce9f3f4e287b60cea.png";